import axios from "axios";
export default {
    inject: ["openShowModalLoading", "closeShowModalLoading"],
    data() {
        return {
            pathResource: "/notificationnotipay",
            listaNotificationNotipay: [],
            notificationNotipayDettaglio: {},
            rows: 0,
        };
    },
    methods: {
        listaNotificationNotipayLoadData(afterLoad = null) {
            this.openShowModalLoading();
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResource;
            axios
                .get(link)
                .then((response) => {
                    this.listaNotificationNotipay = response.data.data.list;
                    this.rowsNotification = response.data.data.recordsNumber;
                    this.closeShowModalLoading();
                    if (afterLoad != null) {
                        afterLoad();
                    }
                })
                .catch((error) => {
                    this.closeShowModalLoading();
                    console.log("Il servizio dei Pai Domiciliare ha datao errore: " + error.response.status);
                });
        },
        notificationNotipayDettaglioLoadData(id, afterLoad = null) {
            if (id) {
                this.openShowModalLoading();
                let me = this;
                let link = process.env.VUE_APP_PATH_API + me.pathResource + "/" + id;
                axios
                    .get(link)
                    .then((response) => {
                        this.notificationNotipayDettaglio = response.data.data;
                        this.closeShowModalLoading();
                        if (afterLoad != null) {
                            afterLoad();
                        }
                    })
                    .catch((error) => {
                        this.closeShowModalLoading();
                        console.log("Il servizio dei Pai Domiciliare ha datao errore: " + error.response.status);
                    });
            } else {
                this.$bvToast.toast("Id non valido", {
                    title: "Attenzione",
                    variant: "danger",
                    solid: true,
                });
            }
        },
    },
};
